import { createSelector } from '@ngrx/store';
import { getRmsSpecificationPage } from './index';
import { Slot, State } from './../reducers/open-platform/slots.reducer';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

export const getSlotsState = createSelector(getRmsSpecificationPage, state => state.slotsLegacyState);
export const getSlotsOpenPlatformState = createSelector(getRmsSpecificationPage, state => state.slotsOpenPlatformState);

export const getOpenPlatformSlots = createSelector(getSlotsOpenPlatformState, state => {
  const slots: Slot[] = [];
  for (const key in state.entities) {
    if (Object.prototype.hasOwnProperty.call(state.entities, key)) {
      slots.push(state.entities[key]);
    }
  }
  return slots;
});

export const getSlotsResponse = createSelector(getSlotsState, state => state.response);

export const getSlotsAvailability = createSelector(getSlotsState, state => state.availableSchedule);

export const getSlotsFetched = createSelector(getSlotsState, state => state.fetched);

export const getSlotsLoading = createSelector(getSlotsState, state => state.loading);

export const getSlotAvailable = createSelector(getSlotsState, state => state.availableDate);

export const getSlotWaitingListDefaulted = createSelector(getSlotsState, state => state.waitingListDefaulted);

export const getSlotError = createSelector(getSlotsState, state => state.error);

export const getOpenPlatformSlotError = createSelector(getSlotsOpenPlatformState, (state: State, props: any) => {
  const slots: Slot[] = [];
  for (const key in state.entities) {
    if (Object.prototype.hasOwnProperty.call(state.entities, key)) {
      slots.push(state.entities[key]);
    }
  }
  if (slots[props.formIndex]) {
    slots[props.formIndex].error;
  }
  return null;
});

export const getSlotsErrors = createSelector(getSlotsState, getSlotsOpenPlatformState, (slot, slotOP) => {
  return { slotError: slot.error, slotOPError: _safe(() => slotOP.entities[0].error) };
});
